module.exports = __webpack_public_path__ + "img/121ca47b61a70e39556b3d3b42fd13bf.gif";